import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppSettings } from '../../../shared/PRE-LOAD/app-settings';
import { EventsService } from '../../../shared/services/events/events.service';
import { UserSelectionsService } from '../../../shared/services/user-selections/user-selections.service';
import { Product } from '../../../shared/types/product.type'
import { Journey, JourneySteps } from '../../../shared/types/strings.type'
import { JourneyConfig } from '../../config/journey';
import { AnalyticsService } from '../../../shared/services/analytics/analytics.service';
import { listLazyRoutes } from '@angular/compiler/src/aot/lazy_routes';


@Component({
    selector: 'event-appointment',
    templateUrl: './event-appointment.component.html',
    styleUrls: ['./event-appointment.component.scss', '../../styles.event.scss']
})
export class EventAppointmentComponent implements OnInit {

    constructor(
        private router: Router,
        private userSelectionService: UserSelectionsService,
        private analytics: AnalyticsService
    ) {
    }

    showSubmit: boolean;
    journeySteps: Array<JourneySteps>= JourneyConfig.steps;
    header: Journey 
    isOffsite:boolean = false;

    ngOnInit() {

      let event =  this.userSelectionService.get('product');

       this.header = {
            title: `Book an appointment`,
            instruction: `${event.title} Appointment`
        };

        this.analytics.setEventForm(event.title,this.header.title);
    }

    currentDayCount($event) {
        
        this.showSubmit = $event.days > 0;

        if($event.singleTime){
            this.proceed()
        }
        
    }

    proceed() {
        this.router.navigate(['event-personal-information'], { skipLocationChange: true, fragment: 'rttd' });
    }
}
